<app-mobile-filter (clearFilters)="onClearFilters()" (close)="onCloseModal()">
  <ng-container content>
        <!-- filtrowanie po budynku -->
        <ion-col
        *ngIf="buildingServ.buildings.length > 1"
        class="ion-no-padding"
        size="12"
      >
        <ion-item lines="full" (click)="showBuildings = !showBuildings">
          <ion-label>{{ "SPACE.BUILDING" | translate }}</ion-label>
          <ion-icon
            slot="end"
            name="chevron-down"
            [@toggleRotate]="showBuildings ? 'active' : 'inactive'"
          ></ion-icon>
        </ion-item>
      </ion-col>
      <ion-col
      *ngIf="buildingServ.buildings.length > 1"
        class="ion-no-padding overflow-hidden"
        size="12"
        [@toggleHeight]="showBuildings ? 'active' : 'inactive'"
      >
      <ion-radio-group 
        (ionChange)="onFilterBuilding($event.detail.value)" 
        [value]="parkingReportServ.request.building"
      >
        <ion-item>
          <ion-radio slot="start" [value]="null"></ion-radio>
          <ion-label>{{ "ALL" | translate }}</ion-label>
        </ion-item>
        <ion-item *ngFor="let building of buildingServ.buildings" >
          <ion-radio slot="start" [value]="building"></ion-radio>
          <ion-label>{{ building.name }}</ion-label>
        </ion-item>
      </ion-radio-group>
      </ion-col>
  
      <!-- filtrowanie po firmie -->
      <ng-container *appHasRole="['company.view']">
        <ion-col
          *ngIf="companyServ.companies.length > 1"
          class="ion-no-padding"
          size="12"
        >
          <ion-item lines="full" (click)="showCompanies = !showCompanies">
            <ion-label>{{ "ADD_INVITATION.COMPANY" | translate }}</ion-label>
            <ion-icon
              slot="end"
              name="chevron-down"
              [@toggleRotate]="showCompanies ? 'active' : 'inactive'"
            ></ion-icon>
          </ion-item>
        </ion-col>
        <ion-col
        *ngIf="companyServ.companies.length > 1"
          class="ion-no-padding overflow-hidden"
          size="12"
          [@toggleHeight]="showCompanies ? 'active' : 'inactive'"
        >
        <ion-radio-group 
          (ionChange)="onFilterCompany($event.detail.value)" 
          [value]="parkingReportServ.request.company"
        >
          <ion-item>
            <ion-radio slot="start" [value]="null"></ion-radio>
            <ion-label>{{ "ALL" | translate }}</ion-label>
          </ion-item>
          <ion-item *ngFor="let company of companyServ.companies" >
            <ion-radio slot="start" [value]="company"></ion-radio>
            <ion-label>{{ company.name }}</ion-label>
          </ion-item>
        </ion-radio-group>
        </ion-col>
      </ng-container>
  
      <!-- Filtrowanie po datach -->
      <ion-col size="12" class="ion-no-padding">
        <ion-item lines="full" (click)="showDates = !showDates">
          <ion-label>Data</ion-label>
          <ion-icon
            slot="end"
            name="chevron-down"
            [@toggleRotate]="showDates ? 'active' : 'inactive'"
          ></ion-icon>
        </ion-item>
      </ion-col>
      <ion-col
        class="ion-no-padding overflow-hidden"
        size="12"
        [@toggleHeight]="showDates ? 'active' : 'inactive'"
      >
        <ion-item lines="none" class="parking-report-modal-filter__date-container">
          <span class="margin-right-8">
            {{ "FROM:" | translate }}
          </span>
          <app-date-time-picker
            class="selectdate parking-report-modal-filter__date"
            cssClass="border-0"
            [value]="parkingReportServ.requestParameters.dateFrom"
            pickerType="calendar"
            placeholder="{{ 'ADMIN.parking_REPORT.SELECT_DAY' | translate }}"
            (afterPickerClosed)="onFilterDate($event, 'start')"
          ></app-date-time-picker>
        </ion-item>
        <ion-item lines="full" class="parking-report-modal-filter__date-container">
          <span class="margin-right-8">
            {{ "TO:" | translate }}
          </span>
          <app-date-time-picker
            class="selectdate parking-report-modal-filter__date"
            cssClass="border-0"
            [value]="parkingReportServ.requestParameters.dateTo"
            pickerType="calendar"
            placeholder="{{ 'ADMIN.parking_REPORT.SELECT_DAY' | translate }}"
            (afterPickerClosed)="onFilterDate($event, 'end')"
          ></app-date-time-picker>
        </ion-item>
      </ion-col>
    </ng-container>
  
    <ng-container button>
      <ng-container *ngIf="parkingReportServ.filterDetailsShowLoader">
        <img src="./assets/loading.svg" class="parking-filter-modal__loader" />
      </ng-container>
      <ng-container>
        {{ parkingReportServ.parkingBookings.length }}
      </ng-container>
    </ng-container>

</app-mobile-filter>
